import { render, staticRenderFns } from "./company2.vue?vue&type=template&id=d2a5bdce&scoped=true"
import script from "./company2.vue?vue&type=script&lang=js"
export * from "./company2.vue?vue&type=script&lang=js"
import style0 from "./company2.vue?vue&type=style&index=0&id=d2a5bdce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2a5bdce",
  null
  
)

export default component.exports